export default "__VITE_ASSET__DHaLcIIJ__"